import cursorSVG from '@/assets/cursor.svg';
import { Drawer, Space, Typography } from "antd";
import { useTranslation } from 'react-i18next';
type GuideDialogProps = {
    open: boolean;
    onClose: () => void;
}

const { Title, Text } = Typography;

const GuideDialog = ({ open, onClose }: GuideDialogProps) => {
    const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
    const { t } = useTranslation('common');
    const websiteTitle = import.meta.env.VITE_WEB_TITLE ?? 'Aitomistic Hub';
    return <Drawer size="large" classNames={{
        body: 'bg-neutral-200 dark:bg-[#333333]',
    }} title={t('guide.title', { title: websiteTitle })} onClose={onClose} open={open}>
        <div className='flex flex-col items-center justify-center h-full w-full'>
            <Title level={3} className=' mb-4'>
                {t('guide.shortcut_keys')}
            </Title>
            <Space orientation='vertical' size='large'>
                <div className='flex flex-col items-center justify-center flex-1 px-6'>
                    <Title level={5}>
                        {t('guide.save_file')} <Text keyboard>{isMac ? 'Command' : 'Ctrl'}</Text> + <Text keyboard>S</Text>
                    </Title>
                    <Title level={5}>
                        {t('guide.copy_file')} <Text keyboard>{isMac ? 'Command' : 'Ctrl'}</Text> + <Text keyboard>C</Text>
                    </Title>
                    <Title level={5}>
                        {t('guide.paste_file')} <Text keyboard>{isMac ? 'Command' : 'Ctrl'}</Text> + <Text keyboard>V</Text>
                    </Title>
                    <Title level={5}>
                        {t('guide.submit_file')} <Text keyboard>{isMac ? 'Command' : 'Ctrl'}</Text> + <Text keyboard>R</Text>
                    </Title>
                    <Title level={5} className='flex flex-row justify-center'>
                        {t('guide.select_multiple')} <Text keyboard>Shift</Text> + <img src={cursorSVG} className='svg-icon-dark w-6 h-6' />
                    </Title>
                </div>
            </Space>
        </div>
    </Drawer>
}

export default GuideDialog;